import script from "./SessionDetailComponentFebruary4.vue?vue&type=script&setup=true&lang=js"
export * from "./SessionDetailComponentFebruary4.vue?vue&type=script&setup=true&lang=js"

import "./SessionDetailComponentFebruary4.vue?vue&type=style&index=0&id=668b35e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-668b35e4"]])

export default __exports__